import { render } from "./customizerconfiguration.vue?vue&type=template&id=719a31bc"
import script from "./customizerconfiguration.vue?vue&type=script&lang=js"
export * from "./customizerconfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__